import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "group-chat__banner" }
const _hoisted_2 = {
  key: 0,
  class: "group-chat__loading"
}
const _hoisted_3 = {
  key: 1,
  class: "group-chat__loading"
}
const _hoisted_4 = {
  key: 2,
  class: "group-chat__empty"
}
const _hoisted_5 = { class: "group-chat__meta" }
const _hoisted_6 = { class: "group-chat__author" }
const _hoisted_7 = { class: "group-chat__time" }
const _hoisted_8 = { class: "group-chat__text" }
const _hoisted_9 = {
  key: 3,
  class: "group-chat__typing"
}
const _hoisted_10 = { class: "group-chat__input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["group-chat", _ctx.viewClass])
  }, [
    _createElementVNode("div", {
      class: "group-chat__header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cycleState && _ctx.cycleState(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["group-chat__title", { 'group-chat__title--flash': _ctx.newMessageFlash }])
      }, _toDisplayString(_ctx.chatTitle), 3),
      _createVNode(_component_q_space),
      (_ctx.viewState !== 'expanded' && _ctx.unreadCount > 0)
        ? (_openBlock(), _createBlock(_component_q_badge, {
            key: 0,
            color: "red",
            floating: "",
            label: _ctx.unreadCount,
            class: "q-mr-sm"
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_btn, {
        flat: "",
        dense: "",
        round: "",
        icon: _ctx.headerIcon,
        size: "sm",
        onClick: _withModifiers(_ctx.cycleState, ["stop"])
      }, null, 8, ["icon", "onClick"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, " This chat is not visible to users with “viewer” role ", 512), [
      [_vShow, _ctx.viewState !== 'collapsed']
    ]),
    _withDirectives(_createElementVNode("div", {
      ref: "messageList",
      class: "group-chat__messages",
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      (_ctx.loadingOlder)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Loading older messages… "))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading…"))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.messages.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No chat history yet "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
        return (_openBlock(), _createElementBlock("div", {
          key: msg.id,
          class: _normalizeClass(["group-chat__bubble", { 'group-chat__bubble--own': msg.userId === _ctx.currentUserId }])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(msg.userName), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatTime(msg.timestamp)), 1),
            (msg.userId === _ctx.currentUserId)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "delete_outline",
                  size: "xs",
                  color: "grey-6",
                  class: "group-chat__delete",
                  onClick: ($event: any) => (_ctx.deleteMessage(msg.id))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(msg.text), 1)
        ], 2))
      }), 128)),
      (_ctx.someoneTyping)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", null, "Someone is typing", -1),
            _createElementVNode("span", { class: "typing-dots" }, [
              _createElementVNode("span"),
              _createElementVNode("span"),
              _createElementVNode("span")
            ], -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 544), [
      [_vShow, _ctx.viewState !== 'collapsed']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createVNode(_component_q_input, {
        modelValue: _ctx.draft,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draft) = $event)),
        dense: "",
        outlined: "",
        placeholder: "Type a message…",
        class: "group-chat__field",
        maxlength: "2000",
        error: _ctx.isOverLimit,
        "error-message": `Message exceeds ${2000} characters`,
        "hide-bottom-space": "",
        onKeydown: _withKeys(_withModifiers(_ctx.send, ["prevent"]), ["enter"])
      }, {
        append: _withCtx(() => [
          (_ctx.draft.length > 1800)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["group-chat__char-count", { 'group-chat__char-count--over': _ctx.isOverLimit }])
              }, _toDisplayString(_ctx.charsRemaining), 3))
            : _createCommentVNode("", true),
          _createVNode(_component_q_btn, {
            flat: "",
            dense: "",
            round: "",
            icon: "send",
            color: "primary",
            disable: !_ctx.draft.trim() || _ctx.sending || _ctx.isOverLimit,
            loading: _ctx.sending,
            onClick: _ctx.send
          }, null, 8, ["disable", "loading", "onClick"])
        ]),
        _: 1
      }, 8, ["modelValue", "error", "onKeydown"])
    ], 512), [
      [_vShow, _ctx.viewState !== 'collapsed']
    ])
  ], 2))
}